module.exports = __webpack_public_path__ + "vfn-assets/img/equipaje-400.1a3c2b9d.svg";